import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiAccountMultiple, mdiChevronDown, mdiChevronUp } from "@mdi/js";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { MenuWithSubmenu } from "./Menu";

export const VendorsMenu: React.FC<MenuWithSubmenu> = memo(
  ({ handleClick, leftMenuOpen, openSubmenu, user }) => {
    const { t } = useTranslation();

    if (
      !(
        user.roles_names.includes("View All Vendors") ||
        user.roles_names.includes("Edit All Vendors") ||
        user.roles_names.includes("Can Invite") ||
        user.roles_names.includes("Brand Exclusive - View")
      )
    ) {
      return null;
    }

    return (
      <>
        <ListItemButton
          // name="vendors"
          onClick={() => handleClick("vendors")}
          title={t("menu.vendors.title")}
        >
          <ListItemIcon sx={{ minWidth: "2rem" }}>
            <Icon icon={mdiAccountMultiple} />
          </ListItemIcon>
          {!!leftMenuOpen && (
            <ListItemText
              primary={t("menu.vendors.title")}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: 14,
                  },
                },
              }}
              sx={{ whiteSpace: "normal" }}
            />
          )}
          <Icon icon={openSubmenu.vendors ? mdiChevronUp : mdiChevronDown} />
        </ListItemButton>
        <Collapse in={openSubmenu.vendors} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {(user.roles_names.includes("View All Vendors") ||
              user.roles_names.includes("Edit All Vendors")) && (
              <HybridRouteListItemButtonLink
                caption="vendors catalog"
                name="vendors[catalog]"
                sx={{ pl: 4 }}
                title={t("menu.vendors.submenu.catalog.title")}
                url="/vsupplierregistration/vendors"
              >
                <ListItemText
                  primary={t("menu.vendors.submenu.catalog.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.roles_names.includes(
              "Vsupplierregistration - View Category Panel",
            ) && (
              <HybridRouteListItemButtonLink
                caption="vendors category panel"
                isReact={false}
                name="vendors[categoryPanel]"
                sx={{ pl: 4 }}
                title={t("menu.vendors.submenu.categoryPanel.title")}
                url="/vsupplierregistration/vendors/category_panel"
              >
                <ListItemText
                  primary={t("menu.vendors.submenu.categoryPanel.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.roles_names.includes("Brand Exclusive - View") && (
              <HybridRouteListItemButtonLink
                caption="vendors brand exclusive"
                name="vendors[brandExclusive]"
                sx={{ pl: 4 }}
                title={t("menu.vendors.submenu.brandExclusive.title")}
                url="/vsupplierregistration/exclusive_brands"
              >
                <ListItemText
                  primary={t("menu.vendors.submenu.brandExclusive.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}
          </List>
        </Collapse>
      </>
    );
  },
);
